import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FooterService } from '../../core/services/footer.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, TegelModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  private footerService = inject(FooterService);

  isCollapsed = this.footerService.isCollapsed;

  toggleFooter() {
    this.footerService.toggleFooter();
  }
} 